import { api } from "apiConnections";
import { AxiosRequestConfig } from "axios";
import RequestUrlId from "types/RequestUrlId";

const requests = {
    destroy: (config: AxiosRequestConfig, url: RequestUrlId) =>
        api.delete(`/restaurant-products/reviews/${url.id}`, config),
    fetch: (config: AxiosRequestConfig) => api.get(`/restaurant_products/reviews`, config),
    get: (config: AxiosRequestConfig, url: RequestUrlId) =>
        api.get(`/restaurant-products/reviews/${url.id}`, config),
    store: (data: object, config: AxiosRequestConfig) =>
        api.post(`/restaurant-products/reviews`, data, config),
    update: (data: object, config: AxiosRequestConfig, url: RequestUrlId) =>
        api.put(`/restaurant-products/reviews/${url.id}`, data, config),
};

export default requests;
